<template>
  <div class="page-container">
    <div class="page_title">
      <div class="page_title_desc">采购方黑名单</div>
    </div>
    <el-divider></el-divider>
    <!--工具栏-->
    <div class="toolbar">
      <el-form :inline="true" :model="filterForm" :size="size">
        <el-form-item>
          <!-- <el-select v-model="filterForm.purchaseNo" clearable filterable placeholder="请选择采购方名称">
            <el-option
              v-for="item in purchaserList"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            ></el-option>
          </el-select> -->
          <el-input v-model="filterForm.purchaseName" clearable placeholder="请输入采购方名称"></el-input>
        </el-form-item>
        <!-- <el-form-item>
          <el-select
            v-model="filterForm.carLicensePlateNo "
            clearable
            filterable
            placeholder="请选择车牌号"
          >
            <el-option
              v-for="(item, index) in carLicensePlateNoList"
              :key="index"
              :label="item.name"
              :value="item.code"
            ></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item>
          <el-input v-model="filterForm.driverName" placeholder="请输入司机姓名" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="filterForm.driverPhone" placeholder="请输入司机手机号" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="filterForm.idCard" placeholder="请输入司机身份证" clearable></el-input>
        </el-form-item>
        <el-form-item>

          <el-date-picker
            v-model="filterForm.createTime"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            range-separator="至"
            start-placeholder="拉黑开始日期"
            end-placeholder="拉黑结束日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <kt-button
            icon="fa fa-search"
            label="搜索"
            perms="-1"
            type="primary"
            @click="handleSearch"
          />
        </el-form-item>
        <el-form-item>
          <kt-button
            icon="fa fa-share"
            label="重置"
            perms="-1"
            @click="handleReset"
            type="primary"
          />
        </el-form-item>
      </el-form>
    </div>
    <!--表格树内容栏-->
    <el-table
      v-loading="loading"
      :data="blacklistList"
      stripe
      size="mini"
      style="width: 100%;"
      row-key="id"
    >
      <el-table-column type="index" width="50" align="center" fixed label="序号"></el-table-column>
      <el-table-column prop="purchaseName" align="center" label="采购方名称"></el-table-column>
      <el-table-column prop="driverName" align="center" label="姓名"></el-table-column>
      <el-table-column prop="driverPhone" align="center" label="司机手机号"></el-table-column>
      <el-table-column prop="idCard" align="center" label="身份证号"></el-table-column>
      <el-table-column prop="createTime" align="center" label="拉黑时间"></el-table-column>
      <!-- <el-table-column prop="removeBlackListTime" align="center" label="移出黑名单时间"></el-table-column> -->
    </el-table>
    <!--分页栏-->
    <div class="toolbar" style="padding:20px;">
      <el-pagination
        background
        layout="total, prev, pager, next"
        @current-change="refreshPageRequest"
        :current-page="pageNo"
        :page-size="pageSize"
        :total="totalSize"
        style="float:right;"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import KtButton from "@/components/Core/KtButton";

export default {
  components: {
    KtButton
  },
  data() {
    return {
      size: "small",
      pageNo: 1,
      pageSize: 10,
      totalSize: 0,
      loading: false,
      blacklistList: [],
      purchaserList: [],
      carLicensePlateNoList: [],
      filterForm: {
        purchaseName: "",
        driverName:'',
        driverPhone:'',
        idCard:'',
        carLicensePlateNo: "",
        createTime: ""
      }
    };
  },
  mounted() {
    this.getBlacklistList();
    this.getPetPurchaserList();
    // this.getAllCarLicensePlateNoList();
  },
  methods: {
    // 获取采购方黑名单
    async getBlacklistList() {
      this.loading = true;
      const params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize
      };
      let index = 0;
      for (let key in this.filterForm) {
        const val = this.filterForm[key];
        if (val && val !== "") {
          params["searchFieldList[" + index + "].fieldName"] = key;
          if (key === "createTime") {
            params["searchFieldList[" + index + "].rangeMinValue"] = val[0];
            params["searchFieldList[" + index + "].rangeMaxValue"] = val[1];
          } else {
            params["searchFieldList[" + index + "].singleValue"] = val;
          }
          index++;
        }
      }
      // console.log(params);
      let res = await this.$api.blacklist.getDriverBlackList(params);
      this.totalSize = res.data.totalSize;
      if (res.data && res.data.dtoList && res.data.dtoList.length > 0) {
        this.blacklistList = res.data.dtoList;
      } else {
        this.blacklistList = [];
      }
      this.loading = false;
    },
    // 换页刷新
    refreshPageRequest(pageNo) {
      this.pageNo = pageNo;
      this.getBlacklistList();
    },
    // 搜索
    handleSearch() {
      this.pageNo = 1;
      this.getBlacklistList();
    },
    // 重置
    handleReset() {
      this.filterForm = {
        purchaseName: "",
        carLicensePlateNo: "",
        createTime: ""
      };
      this.handleSearch();
    },
    // 获取采购方列表
    async getPetPurchaserList() {
      let res = await this.$api.purchaser.mGetEjyAllPurchaseList()
      if (res.data && res.data.length > 0) {
        this.purchaserList = res.data.filter(item => item.name)
      } else {
        this.purchaserList = [];
      }
    },
    // 获取车辆车牌号
    // getAllCarLicensePlateNoList() {
    //   this.$api.blacklist.getAllCarLicensePlateNoList().then(res => {
    //     if (res.data && res.data.length > 0) {
    //       this.carLicensePlateNoList = res.data;
    //     } else {
    //       this.carLicensePlateNoList = [];
    //     }
    //   });
    // }
  }
};
</script>

<style lang="scss" scoped>
.page-container{
  box-sizing: border-box;
  padding: 10px;
}
.toolbar {
  width: 100%;
  box-sizing: border-box;
  padding: 10px 10px 30px;
}
</style>
